export default __webpack_public_path__ + "static/media/BEN.2f321c9a.svg";